import FileGroupModal from './FileGroupModal'

export default FileGroupModal
